import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { defineMessages, injectIntl } from "react-intl";
import "./PayNoPainErrorMessage.scss";

export const msgs = defineMessages({
  code104: {
    id: "payNoPainErrorMessage.invalidTransaction",
    description: "Transaction not allowed",
    defaultMessage: "Invalid credit card",
  },
  genericError: {
    id: "payNoPainErrorMessage.genericError",
    description: "Any other error occured",
    defaultMessage: "The transaction could not be completed.",
  },
  tryAgain: {
    id: "payNoPainErrorMessage.tryAgain",
    description: "Try again message",
    defaultMessage: "Please Try Again.",
  },
});

function getPayNoPainLocalizedErrorMessage({ responseCode }) {
  switch (responseCode) {
    case "101":
    case "102":
    case "104":
    case "110":
    case "114":
    case "129":
    case "180":
    case "184":
    case "190":
    case "191":
      return msgs.code104;
    default:
      return msgs.genericError;
  }
}

function PayNoPainErrorMessage({ transaction, intl: { formatMessage } }) {
  return (
    <div className={"wbkv9-PayNoPainErrorMessage"}>
      <div>
        <div>
          {formatMessage(
            getPayNoPainLocalizedErrorMessage({ responseCode: transaction.responseCode })
          )}
        </div>
        <div>{formatMessage(msgs.tryAgain)}</div>
      </div>
    </div>
  );
}

PayNoPainErrorMessage.propTypes = {
  items: PropTypes.array.isRequired,
};

export default injectIntl(pure(PayNoPainErrorMessage));
